import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["disabled"];
var _hoisted_2 = {
    key: 0,
    class: "checkout-form__title"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormBlock',
    props: {
        disabled: Boolean,
        alwaysVisible: Boolean,
        title: String,
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("fieldset", {
                class: _normalizeClass(["checkout-form__block", { 'always-visible': __props.alwaysVisible }]),
                disabled: __props.disabled
            }, [
                (__props.title || _ctx.$slots.title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "title", {}, function () { return [
                            _createTextVNode(_toDisplayString(__props.title), 1 /* TEXT */)
                        ]; })
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _renderSlot(_ctx.$slots, "default")
            ], 10 /* CLASS, PROPS */, _hoisted_1));
        };
    }
});
